import React from 'react';
import { useDispatch } from 'react-redux';

import { MODAL_TEST_IDS } from 'apps/web_forms/utils/constants';
import { resetModal } from 'apps/web_forms/slices/appSlice';
import Modal from 'apps/web_forms/components/commons/Modal';

export const LocationFailureModal = () => {
  const dispatch = useDispatch();

  return (
    <Modal
      mainMessage='Failed getting user location'
      helpTip="To send a geofenced form it's necessary to allow browser location first"
      testId={MODAL_TEST_IDS.LOCATION_FAILURE_MODAL}
      isOpen={true}
      setIsOpen={() => dispatch(resetModal())}
      icon='error'
    />
  );
};
